module.exports = __webpack_public_path__ + "static/media/imageio9.72e78168.jpg";